<template>
  <div id="experienced-occupation" class="mb-3 pt-5 text-center">
    <div class="size-18 fw-bold mb-3">プロフィール（職務経歴情報）</div>
  </div>
  <ExperiencedOccupation />
  <ExperiencedCompany />
  <ExperiencedIndustry />
  <ExperiencedSkill />
  <SelfDescription />
  <PortfolioUrl />
  <WorkExperienceDescription />
</template>

<script setup lang="ts">
import ExperiencedOccupation from './ExperiencedOccupation.vue';
import ExperiencedCompany from './ExperiencedCompany.vue';
import ExperiencedIndustry from './ExperiencedIndustry.vue';
import ExperiencedSkill from './ExperiencedSkill.vue';
import SelfDescription from './SelfDescription.vue';
import PortfolioUrl from './PortfolioUrl.vue';
import WorkExperienceDescription from './WorkExperienceDescription.vue';
</script>
